<template>
    <!-- eslint-disable -->
    <b-container fluid>
        <div v-if="dealers.length > 0">
            <div>
                <b-row class="justify-content-md-center">
                    <b-col cols="12" md="auto" class="text-center">
                        <b-form-group horizontal label="Search:" :label-cols="2" label-class="text-sm-right">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <img src="https://cdn2.hubspot.net/hubfs/2029938/Assets%20%28Feb%202017%29/location%20%282%29.png" style="padding: 10px">
                                </b-input-group-prepend>

                                <b-form-input @keydown.native="zipCodeKeyDown" v-model="zipCode" placeholder="Enter Zip/Postal Code"></b-form-input>

                                <b-input-group-append>
                                    <b-btn variant="danger" @click="renderMap">Find</b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                    </b-col>
                    <b-col id="elementForWidth">
                    </b-col>
                </b-row>
                <b-row v-show="showMap" class="mt-2" id="resultsElement">
                    <b-col sm="4">
                        <div class="dealers w-100" v-bind:style="{height: mapHeightPx + 'px'}">
                            <div>
                                <div v-for="dealer in nearestDealers" :key="dealer.id" class="address">
                                    <b-card >
                                        <div class="card-text">
                                            <div>
                                                <span class="dealer-label">{{dealer.label}}</span>
                                                <h5>{{dealer.name}} <span v-bind:class="['stars', 'stars-' + dealer.stars ]"></span></h5>
                                            </div>
                                            <div class="distance">
                                                <p>DISTANCE: {{ dealer.distance }} mi</p>
                                            </div>
                                            <div class="address-container">
                                                <p><span><img src="https://cdn2.hubspot.net/hubfs/2029938/Assets%20(Feb%202017)/shape-1.svg?t=1487940049000"></span>{{ dealer.streetAddress }}, {{ dealer.city }}, {{ dealer.postalCode }}</p>
                                                <p class="direction">
                                                    <a class="get-direction" v-bind:href="'https://maps.google.com?daddr=' + dealer.streetAddress + ',' + dealer.city + ',' + dealer.postalCode" target="_blank">Get Directions</a>
                                                </p>
                                            </div>
                                            <div class="phone-number" v-if="dealer.phone">
                                                <p><span><img src="https://cdn2.hubspot.net/hubfs/2029938/Assets%20(Feb%202017)/phone.svg?t=1487940049000"></span><a v-bind:href="'tel:'+ dealer.phone">{{ dealer.phone }}</a></p>
                                            </div>
                                            <div class="email" v-if="dealer.salesEmail">
                                                <p><span><img src="https://cdn2.hubspot.net/hubfs/2029938/Assets%20(Feb%202017)/mail.svg?t=1487940049000"></span><a v-bind:href="'mailto:' + dealer.salesEmail">{{ dealer.salesEmail }}</a></p>
                                            </div>
                                            <div class="web-link" v-if="dealer.website">
                                                <p><span><img src="https://cdn2.hubspot.net/hubfs/2029938/Assets%20(Feb%202017)/link.svg?t=1487940049000"></span><a target="blank" v-bind:href="dealer.website">{{ dealer.website }}</a></p>
                                            </div>

                                            <div class="dealer-cta">
                                                <b-button class="my-dealer" size="lg" variant="outline-danger" @click="makeMyDealer(dealer)">SELECT DEALER</b-button>
                                            </div>
                                        </div>
                                    </b-card>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="8">
                        <div class="google-map w-100" id="mapDiv" v-bind:style="{height: mapHeightPx + 'px'}"></div>
                    </b-col>
                </b-row>
                <b-row v-if="!showMap" >
                    <b-col class="m-5 text-center">
                        <div v-if="showError" class="please-search">Sorry, we don't have information for your zip or postal code, please try another one.</div>
                        <div v-if="zipCode === ''" class="please-search">Please enter zip or postal code to search for dealers.</div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="not-in-us m-5 text-center">
                        <h5>Not in the US/Canada? Find <a href="//info.chiohd.com/international-dealers" title="Garage Door Dealers" target="_blank">Garage Door Dealers Outside of the United States and Canada</a></h5>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */// because this component was written by a third party
import axios from 'axios';
import { mapActions, mapState } from 'vuex';

const google = window.google;
const mapApiKey = 'AIzaSyCVHK9PqVuSaqMPPtTvjV_YFqsxmxnKLBA';
const MILES_PER_KM = 0.621371;

async function getCoordinates(zipCode, key) {
  const { data: { results } } = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
    params: {
      components: `postal_code:${zipCode}|country:US`,
      key,
    },
  });

  if (results.length > 0 && results[0].geometry) {
    return results[0].geometry.location;
  }
  return {};
}

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

function get5NearestDealers(zipCoordinates, allDealers) {
    let dealers = allDealers.map(dealerMaster => {
        let dealer = Object.create(dealerMaster)
        dealer.distance = (getDistanceFromLatLonInKm(dealer.lat, dealer.lng, zipCoordinates.lat, zipCoordinates.lng) * MILES_PER_KM).toFixed(2);
        return dealer
    });
    dealers.sort(function (a, b) {
        return a.distance - b.distance;
    });
    return dealers.slice(0, 5)
}

function padZipCode(code) {
    if (!/^\d+$/.test(code) || code.length > 5) {
        return code;
    }
    return ("00000" + code).slice(code.length);
}

function getBoundsFromCoords(coords) {
    var bound = new google.maps.LatLngBounds(coords[0], coords[0]);
    for (var i = 0; i < coords.length; i++) {
        bound.extend(coords[i]);
    }
    return bound;
}

function getBoundsZoomLevel(bounds, mapWidth, mapHeight) {
    const mapDim = {
        width: mapWidth,
        height: mapHeight
    };
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;
    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }
    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

export default {
    data() {
        return {
            zipCode: "",
            showMap: false,
            nearestDealers: [],
            showError: false,
            mapHeightPx: 500
        }
    },
    computed: {
        ...mapState([
            'dealers',
        ]),
    },
    created: async function() {
        await this.getDealers();
    },
    mounted: function() {

    },
    methods: {
        ...mapActions([
            'getDealers',
        ]),
        makeMyDealer: function(dealer) {
            this.$emit('dealerSelected', dealer)
        },
        zipCodeKeyDown: function(event) {
            this.showError = false
            if (event.which === 13) {
                this.renderMap()
            }
        },
        renderMap: function() {
            this.showMap = false
            this.showError = false
            this.nearestDealers = []
            if (this.zipCode === "")
                return
            getCoordinates(this.zipCode, mapApiKey).then(zipCoordinates => {
                if (!zipCoordinates.lat && !zipCoordinates.lng) {
                    this.showMap = false
                    this.showError = true
                    return
                }

                this.showMap = true
                const mapElement = document.getElementById('mapDiv')
                const options = {
                    zoom: 10,
                    center: zipCoordinates
                }
                const map = new google.maps.Map(mapElement, options);

                this.nearestDealers = get5NearestDealers(zipCoordinates, this.dealers)
                var bounds = getBoundsFromCoords(this.nearestDealers);

                for (var i = 0; i < this.nearestDealers.length; i++) {
                    this.nearestDealers[i].label = String.fromCharCode("A".charCodeAt(0) + i);
                    this.nearestDealers[i].postal_code = padZipCode(this.nearestDealers[i].postal_code);
                    var marker = new google.maps.Marker({
                        position: this.nearestDealers[i],
                        map: map,
                        label: this.nearestDealers[i].label
                    });
                    (function (dealer, i) {
                        marker.addListener("click", function () {
                            var scrollElem = $(".dealers");
                            var item = scrollElem.find(".address").eq(i);
                            if (item.length) {
                                var top = Math.min(item.offset().top - scrollElem.offset().top + scrollElem.scrollTop(), scrollElem[0].scrollHeight);
                                scrollElem.animate({ scrollTop: top }, 500);
                            }
                        });
                    })(this.nearestDealers[i], i);
                }

                var zoomLevel = getBoundsZoomLevel(bounds, $('#elementForWidth').width(), this.mapHeightPx);
                map.setCenter(bounds.getCenter());
                map.setZoom(zoomLevel);
            })


        }
    }
}
</script>

<style scoped>
/* eslint-disable */
.google-map {
  margin: 0 auto;
  background: gray;
}

.dealers{
    overflow: auto
}

.dealer-label {
    background-color: #d41b28;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: .6px;
    text-align: center;
    color: #fff;
    padding: 0 4px;
    float: left;
    margin-right: 10px;
    position: relative;
    top: 4px
}

.stars{color:#fbe200}
.stars-1:before{content:"★"}
.stars-2:before{content:"★★"}
.stars-3:before{content:"★★★"}
.stars-4:before{content:"★★★★"}
.stars-5:before{content:"★★★★★"}

.address p {
    font-size: 12px;
    font-weight: 500;
    line-height: 2.08;
    color: #808285;
    margin-bottom: 11px;
    margin-top: 15px;
}

.address-container p, .phone-number p, .phone-number p a, .email p a, .email p, .web-link p, .web-link p a {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: normal;
    color: #474b51
}

.address-container p, .direction {
    margin-bottom: 0
}

.address-container p span, .phone-number p span, .email p span, .web-link p span {
    position: relative;
    top: -4px;
    padding-right: 12px
}

.get-direction {
    padding-left: 20px;
    padding-bottom: 9px;
    display: block;
    color: #d41b28;
}

.dealer-cta {
    padding: 12px;
    margin-top: 18px;
}

.my-dealer {
    font-size: 13px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
}

.not-in-us a {
    color: #d41b28;
}

.please-search {
    font-size: 1.1em
}
</style>



// WEBPACK FOOTER //
// src/components/share/DealerLocator.vue